ACC.schaHomepageCarousel = {

    _autoload: [
        "init",
        "initSmarteditWatcher",
    ],

    intervalLength: 3000,

    intervalId: null,

    callBacks: [],

    isInIframe: function() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    },

    isInSmartEdit: function() {
        return ACC.schaHomepageCarousel.isInIframe() && !!(window && window.SCHA && window.SCHA.config && window.SCHA.config.isSmartedit);
    },

    addOnNextCallback: function (fun) {
        ACC.schaHomepageCarousel.callBacks.push(fun)
    },

    setActive: function (index) {
        const slider = $('.jsp__home-page-slider__item-container');
        slider.css('transform', 'translateX(-' + 100 * index + '%)');
        slider.data('currentIndex', index);

        const controls = $('.jsp__home-page-slider__controls__item');
        controls.removeClass('active');
        if (controls[index]) {
            controls[index].classList.add('active');
        }

        const cbs = ACC.schaHomepageCarousel.callBacks;
        const tileElement = slider.children()[index];
        for (var i = 0; i < cbs.length; i++) {
            cbs[i](index, tileElement);
        }

        ACC.schaHomepageCarousel.startInterval();
    },

    next: function () {
        const slider = $('.jsp__home-page-slider__item-container');
        const activeIndex = slider.data('currentIndex');

        const banners = slider.children();
        const bannerAmount = banners.length;
        const nextIndex = (activeIndex + 1) % bannerAmount;

        ACC.schaHomepageCarousel.setActive(nextIndex);
    },

    previous: function () {
        const slider = $('.jsp__home-page-slider__item-container');
        const activeIndex = slider.data('currentIndex');

        const banners = slider.children();
        const bannerAmount = banners.length;
        let previousIndex = activeIndex - 1;
        if (previousIndex < 0) {
            previousIndex += bannerAmount;
        }

        ACC.schaHomepageCarousel.setActive(previousIndex);
    },

    init: function () {
        const hasSlider = $('.jsp__home-page-slider__item-container').length > 0;
        if (!hasSlider) {
            return;
        }
        $('.jsp__home-page-slider__controls [data-type=previous]')
            .removeAttr('hidden')
            .on('click',  ACC.schaHomepageCarousel.previous);
        $('.jsp__home-page-slider__controls [data-type=next]')
            .removeAttr('hidden')
            .on('click', ACC.schaHomepageCarousel.next);
        ACC.schaHomepageCarousel.setActive(0);
        const slider = $('.jsp__home-page-slider__item-container');
        slider.data('currentIndex', 0);

        $('.jsp__home-page-slider__controls__item')
            .each(function (index) {
                $(this).data('index', index);
            })
            .on('click', function () {
                ACC.schaHomepageCarousel.setActive(+$(this).data('index'));
            });
        ACC.schaHomepageCarousel.intervalLength = +slider.parent().data('timeoutLength') || 3000;
        ACC.schaHomepageCarousel.startInterval();
    },

    startInterval: function() {
        const interval = ACC.schaHomepageCarousel.intervalLength;
        clearInterval(ACC.schaHomepageCarousel.intervalId);
        ACC.schaHomepageCarousel.intervalId = setInterval(ACC.schaHomepageCarousel.next, interval);
    },

    initSmarteditWatcher: function () {
        const hasSlider = $('.jsp__home-page-slider__item-container').length > 0;
        if (!hasSlider) {
            return;
        }
        if (ACC.schaHomepageCarousel.isInSmartEdit()) {
            const observer = new MutationObserver(function () {
                ACC.schaHomepageCarousel.init();
            });

            const config = {
                childList: true,
            };

            const slider = $('.jsp__home-page-slider').parent()[0];
            observer.observe(slider, config);
        }
    },
};

